export const AD_FORM_POSITION_IN_RESULT_LIST = 10;
export const AD_FORM_SCRIPTS = 'AD_FORM_SCRIPTS';
export const AVAILABLE_BUNDLE = 'availableBundle';
export const RESULT_PAGE_VERSION_3 = '3';
